/*
 * tutor/events — UIEvent envelope construction + transport (spec §1.3).
 * Every component interaction re-enters the agent loop through here.
 */
import { openTutorStream } from './stream';

const mountTimes = new Map();

export const noteMounted = (componentId) => mountTimes.set(componentId, Date.now());

export function makeEvent(eventType, { componentId, questionId, payload } = {}) {
  const mounted = componentId ? mountTimes.get(componentId) : null;
  return {
    event_type: eventType,
    component_id: componentId || null,
    question_id: questionId || null,
    ts: new Date().toISOString(),
    elapsed_ms: mounted ? Date.now() - mounted : null,
    payload: payload || {},
  };
}

export const startSession = (body, opts) => openTutorStream('/engine/tutor/start', body, opts);

export const sendEvent = (sessionId, event, opts) =>
  openTutorStream('/engine/tutor/event', { session_id: sessionId, event }, opts);

export const sendSay = (sessionId, text, opts) =>
  openTutorStream('/engine/tutor/say', { session_id: sessionId, text }, opts);
